import { createContext, useContext, useState } from 'react';

const ModalContext = createContext({
  guideModal: { open: false, title: '', subTitle: '', callback: () => {} },
  setGuideModal: () => {},
  signModal: { open: false, code: null },
  setSignModal: () => {},
});

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

export const ModalProvider = ({ children }) => {
  const [guideModal, setGuideModal] = useState({ open: false, title: '', subTitle: '', callback: () => {} });
  const [signModal, setSignModal] = useState({ open: false, code: null });

  const resetGuideModal = () => {
    setGuideModal({ open: false, title: '', subTitle: '', callback: () => {} });
  };

  return (
    <ModalContext.Provider value={{ guideModal, setGuideModal, signModal, setSignModal, resetGuideModal }}>
      {children}
    </ModalContext.Provider>
  );
};
